import React, { SetStateAction, Dispatch } from "react";
import { useDispatch } from "react-redux";

import { useHistory, useParams } from "react-router";
import { openDictionaryDetails } from "src/app/components/DictionaryDetails/methods";
import { deleteDictionaryElement } from "src/redux";
import { Row } from "src/redux/dictionary/types";
import { deleteGlobalTasks } from "src/redux/creator-database/creatorDatabaseActions";
import { tableDataType } from "src/app/components/Table/Table";
import {
  CreatorShowcaseContext,
  openCreatorShowcase,
} from "src/app/CreatorShowcase/utils";
import { openGlobalTaskDetails } from "src/app/components/GlobalTaskDetails/methods";
import { GlideDataGridContext } from "../../../types";
import ShowDetailsMenuItem from "./ShowDetailsMenuItem";
import RemoveMenuItem from "./RemoveMenuItem";
import GenerateShowcaseMenuItem from "./GenerateShowcaseMenuItem";
import { IConfirmationModal } from "../types";
import CopyLinkMenuItem from "./CopyLinkMenuItem";
import { showErrorToast } from "src/utils/methods";

interface MenuItemsProps {
  context: GlideDataGridContext;
  rowData: Row;
  setIsDropdownOpen: Dispatch<SetStateAction<boolean>>;
  setConfirmationModalSettings: Dispatch<SetStateAction<IConfirmationModal>>;
}

export default function MenuItems({
  context,
  rowData,
  setIsDropdownOpen,
  setConfirmationModalSettings,
}: MenuItemsProps) {
  const history = useHistory();
  const params = useParams<{ workspaceUuid: string; dictionaryUuid: string }>();
  const dispatch = useDispatch();

  switch (context) {
    case tableDataType.Dictionary:
      return (
        <>
          <ShowDetailsMenuItem
            handleClick={() => {
              openDictionaryDetails(history, rowData.uuid);
              setIsDropdownOpen(false);
            }}
          />

          <RemoveMenuItem
            handleClick={() => {
              setConfirmationModalSettings({
                isVisible: true,
                callback: () => {
                  dispatch(
                    deleteDictionaryElement(params.dictionaryUuid, [
                      rowData?.uuid,
                    ]),
                  );
                  setIsDropdownOpen(false);
                },
              });
            }}
          />
        </>
      );

    case tableDataType.CreatorDatabase:
      return (
        <>
          <ShowDetailsMenuItem
            handleClick={() => {
              openGlobalTaskDetails(history, rowData.uuid);
              setIsDropdownOpen(false);
            }}
          />

          <GenerateShowcaseMenuItem
            handleClick={() => {
              openCreatorShowcase({
                history,
                context: CreatorShowcaseContext.CreatorDatabase,
                creatorId: rowData.uuid,
                ids: [rowData.uuid],
                workspaceId: params.workspaceUuid,
              });
              setIsDropdownOpen(false);
            }}
          />

          <CopyLinkMenuItem
            setIsDropdownOpen={setIsDropdownOpen}
            rowData={rowData}
          />

          <RemoveMenuItem
            handleClick={() => {
              setConfirmationModalSettings({
                isVisible: true,
                callback: () => {
                  if (rowData.uuid) {
                    dispatch(deleteGlobalTasks([rowData.uuid]));
                  } else {
                    showErrorToast({
                      id: "ws_element_uuid_not_found",
                      defaultMessage: "Element UUID not found",
                    });
                  }
                  setIsDropdownOpen(false);
                },
              });
            }}
          />
        </>
      );

    default:
      return null;
  }
}
